export enum TimeAccuracy {
    MINUTES = 'Minutes',
    SECONDS = 'Seconds',
    MILLISECONDS = 'Milliseconds'
}
